import { FormEvent, useState } from 'react';
import styles from './styles.module.scss';
import BottomPanel from 'components/panel/BottomPanel';
import { useTranslation } from 'react-i18next';
import { Image, Space } from 'antd-mobile';
import TextButton from 'components/button/TextButton';
import useDirection from 'hooks/useDirection';
import { login } from 'services/auth.service';
import useValidation from 'hooks/useValidation';
import { JOI } from 'utils/joi';
import { delayNavigate, isSuccessCode } from 'utils/common';
import { ROUTES } from 'constants/router';
import { useSelector } from 'store/Store';
import { commonSelector } from 'store/common';
import OpenAppOverlay from 'components/overlay/OpenAppOverlay';
import { APP_LOGO, APP_NAME } from 'constants/common';
import CustomInput from 'components/input/CustomInput';
import { LocalStorage, STORAGE_KEY } from 'utils/localStorage';

type FormDataType = {
  phoneNumber: string;
  password: string;
};

const Storage = new LocalStorage();

export default function LoginContainer() {
  const { t } = useTranslation();
  const { goTo } = useDirection();
  const { isLoading } = useSelector(commonSelector);

  const [formData, setFormData] = useState<FormDataType>({
    phoneNumber: '',
    password: '',
  });
  const { errorMessage, onValidate } = useValidation<FormDataType>({
    phoneNumber: JOI.PHONE_REQUIRE,
    password: JOI.PASSWORD,
  });

  const handleChangeForm = (key: string) => (newValue?: string) => {
    setFormData((prev) => ({
      ...prev,
      [key]: newValue,
    }));
  };

  const handleLogin = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const isError = onValidate(formData);
    if (!isError) {
      const response = await login(formData);
      const { code, data } = response.data;
      if (isSuccessCode(code)) {
        Storage.setStorageItem(STORAGE_KEY.ACCESS_TOKEN, data?.accessToken);
        delayNavigate(() => goTo(ROUTES.HOME)());
      }
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.logo}>
        <div
          style={{
            width: '100px',
            height: '100px',
            background: 'var(--white-01)',
            borderRadius: '100px',
            overflow: 'hidden',
            marginBottom: '24px',
            border: '2px solid var(--white-01)',
          }}
        >
          <Image
            src={APP_LOGO}
            alt="logo"
            style={{
              width: '100%',
              height: '100%',
            }}
          />
        </div>
        <p className={`font-xxxl color-white font-bold`}>{APP_NAME}</p>
      </div>
      <BottomPanel anchors={[window.innerHeight * 0.6]}>
        <p className={`font-xxl font-bold color-black ${styles.title}`}>{t('title.login')}</p>
        <form onSubmit={handleLogin}>
          <Space direction="vertical" block style={{ '--gap': '12px' }}>
            <CustomInput
              title={t('title.phone-number')}
              placeholder={t('placeholder.type-phone-number')}
              errorMessage={errorMessage.phoneNumber}
              value={formData.phoneNumber}
              type="tel"
              onChange={handleChangeForm('phoneNumber')}
            />
            <CustomInput
              title={t('title.password')}
              placeholder={t('placeholder.type-password')}
              errorMessage={errorMessage.password}
              value={formData.password}
              type="password"
              onChange={handleChangeForm('password')}
            />
            <TextButton
              type="submit"
              title={t('button.login')}
              color="warning"
              loading={isLoading}
            />
          </Space>
        </form>
      </BottomPanel>
      <OpenAppOverlay />
    </div>
  );
}
